import { Box, Typography } from "@mui/material";
import React from "react";
import { HelpCircle as HelpIcon } from "react-feather";

/**
 * A quiet "how this is calculated" callout. Insights on this page adjust for
 * bias (e.g. dividing attendance by how many events we run), so the method is
 * spelled out in plain language right next to the numbers — everyone reading
 * the tab can see how a figure was arrived at, and trust it.
 */
const Explainer: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box
    sx={{
      display: "flex",
      gap: 1.25,
      alignItems: "flex-start",
      backgroundColor: "action.hover",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      p: 1.75,
      mb: 2,
    }}
  >
    <Box sx={{ color: "text.secondary", mt: "2px", flex: "0 0 auto" }}>
      <HelpIcon size={16} />
    </Box>
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ "& b": { color: "text.primary" } }}>
        {children}
      </Typography>
    </Box>
  </Box>
);

export default Explainer;
